import VesselParticulars from './VesselParticulars'

export default VesselParticulars
